module.exports = __webpack_public_path__ + "static/media/product2.1831c3c8.jpg";